import { render, staticRenderFns } from "./WomanChildBody.vue?vue&type=template&id=092f3128&scoped=true&"
import script from "./WomanChildBody.vue?vue&type=script&lang=js&"
export * from "./WomanChildBody.vue?vue&type=script&lang=js&"
import style0 from "./WomanChildBody.vue?vue&type=style&index=0&id=092f3128&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092f3128",
  null
  
)

export default component.exports